//
// JSweetAlert.js
//

class JSweetAlert {
    constructor(data) {
        this._data = data?.JTurn?.JSweetAlert ?? [];
    }

    run() {
        const otherOptions = {
            buttonsStyling: false,
            showDenyButton: false,
            denyButtonText: 'Não salve!',
            showCancelButton: false,
            cancelButtonText: 'Não, cancelar!',
            confirmButtonText: 'Ok, entendi!',
            customClass: {
                denyButton: 'btn btn-warning',
                cancelButton: 'btn btn-danger',
                confirmButton: 'btn btn-primary'
            }
        };

        for (const config of this._data) {
            const options = {
                ...otherOptions,
                ...config
            };

            if (config.denyButtonText) {
                options.showDenyButton = true;
            }

            if (config.cancelButtonText) {
                options.showCancelButton = true;
            }

            Swal.fire(options);
        }
    }
}

// Make available globally
window.JSweetAlert = JSweetAlert;